import { getAppInfo, getURLParameter, isIOS, nativeHandler, CleverTapEventV2 } from 'utils';
import globalConstant from 'constants/globalConstant';
import dayjs from 'dayjs';
import { CLEVERTAP } from './cleverTapEventV2';

/**
 * isUpdateApp
 * 		=> false => show hard Update screen
 * 		=> true => check for soft update
 *
 * isLatestApp
 * 		=> true
 * 				=> lastShown in 24 hours => normal user flow
 * 				=> not shown in 24 hours => show soft update screen
 * 		=> false => normal user flow
 */

const isLatestAppForCRM = () => {
	const isPlatformIOS = isIOS || getURLParameter(globalConstant.URL_PARAMETER.PLATFORM) === globalConstant.PLATFORM.IOS;
	if (getURLParameter(globalConstant.URL_PARAMETER.PLATFORM) === 'null') return false;

	const latestStableVersion = isPlatformIOS
		? globalConstant.MINIMUM_JUSPAY_VERSION.IOS
		: globalConstant.MINIMUM_JUSPAY_VERSION.ANDROID;
	const appVersion = getAppVersion() || parseInt(getURLParameter(globalConstant.URL_PARAMETER.APPVERSION)?.trim());

	/**
	 * If any of the required details is missing,
	 * do not show the app update modal
	 */
	if (!appVersion) return false;

	/**
	 * less than minimum juspay version, since we need
	 * everyone to use juspay from now on
	 */
	return appVersion < latestStableVersion;
};

export const isLatestApp = () => {
	if (getURLParameter(globalConstant.URL_PARAMETER.SOURCE) === globalConstant.URL_PARAMETER.CRM) {
		return isLatestAppForCRM();
	}

	const latestStableVersion = isIOS
		? globalConstant.MINIMUM_JUSPAY_VERSION.IOS
		: globalConstant.MINIMUM_JUSPAY_VERSION.ANDROID;
	const minimumStableVersion = isIOS
		? globalConstant.MINIMUM_STABLE_VERSION.IOS
		: globalConstant.MINIMUM_STABLE_VERSION.ANDROID;

	const appVersion =
		getAppVersion() ||
		parseInt(getURLParameter(globalConstant.URL_PARAMETER.APPVERSION).toString().split('.').join('')?.trim());

	if (!appVersion) {
		CleverTapEventV2.send(CLEVERTAP.EVENTS.APP_VERSION_NULL, {
			url: window?.location?.href,
			appInfo: JSON.stringify(getAppInfo()),
		});
	}

	/**
	 * less than minimum juspay version, since we need
	 * everyone to use juspay from now on
	 */
	return appVersion < latestStableVersion;
};

export const canShowSoftUpdate = () => {
	const softUpdateLastShown = localStorage.getItem('softUpdateLastShown');
	if (!softUpdateLastShown) return true;
	const currentTime = dayjs();
	const lastShownTime = dayjs(softUpdateLastShown);
	return currentTime.diff(lastShownTime, 'hour') > 3;
};

export const isUpdatedApp = (appVersionToCheckManually) => {
	const appVersionToCheck = isIOS
		? globalConstant.MINIMUM_STABLE_VERSION.IOS
		: appVersionToCheckManually || globalConstant.MINIMUM_STABLE_VERSION.ANDROID;
	const appVersion = getAppVersion();
	return appVersion >= appVersionToCheck;
};

export const getAppVersion = () => {
	return parseInt(getAppInfo()?.appversion?.toString().split('.').join(''));
};

export const getConsumerId = () => {
	return getAppInfo()?.homeDetails?.consumerId;
};

export const isJuspayEnabled = () => {
	const appVersionToCheck = isIOS
		? globalConstant.MINIMUM_JUSPAY_VERSION.IOS
		: globalConstant.MINIMUM_JUSPAY_VERSION.ANDROID;
	return getAppVersion() >= appVersionToCheck;
};

export const openAppUpdateUrl = () => {
	nativeHandler.openURL(
		isIOS
			? 'https://apps.apple.com/in/app/postpe/id1586002156'
			: 'https://play.google.com/store/apps/details?id=com.postpe.app',
	);
};
